import { apiSlice } from "../api/apiSlice";
import { EditDone } from "../Edit/EditSlice";

export const assignmentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // single video related assignment
        getAssignmentAndMark: builder.query({
            async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
                // check this video have assignment
                const assignment = await fetchWithBQ(
                    `assignments?video_id=${arg.videoId}`
                );
                if (assignment.error) return { error: assignment.error };
                const assignmentId = assignment?.data[0]?.id;
                // check this user submitted assignment 
                const assignmentMark = await fetchWithBQ(
                    `assignmentMark?assignment_id=${assignmentId}&student_id=${arg.studentId}`
                );

                return {
                    data: {
                        isAssignment: !!assignment?.data?.length,
                        assignment: assignment?.data[0],
                        isAssignmentMark: !!assignmentMark?.data?.length,
                        assignmentMark: assignmentMark?.data[0],
                    },
                };
            },
            providesTags: (result, error, arg) => [
                { type: "AssignmentAndMark", id: arg.videoId },
            ]
        }),
        // for leaderboard and dashboard assignment mark section
        getAssignmentMark: builder.query({
            query: () => ({
                url: "/assignmentMark",
            }),
            providesTags: ["AssignmentMark"]
        }),
        assignmentSubmit: builder.mutation({
            query: (data) => ({
                url: `/assignmentMark`,
                method: "POST",
                body: data
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "AssignmentAndMark", id: arg.video_id },
                "AssignmentMark"
            ]

        }),

        // admin api start
        getAssignmentsForAdmin: builder.query({
            query: () => ({
                url: "/assignments"
            }),
            providesTags: ["AssignmentsForAdmin"]
            
        })
    
        ,
        deleteAssignment: builder.mutation({
            query: (id) => ({
                url: `/assignments/${id}`,
                method: "DELETE"
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic assignment cache update
                try {
                    await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getAssignmentsForAdmin", undefined, (draft) => {
                            return draft.filter(item => item.id !== arg)
                        })
                    )
                } catch (err) {
                    // do nothing
                }
            },
            invalidatesTags: ["getVideosForAssignAssignment"]
        }),
        addAssignment: builder.mutation({
            query: (data) => ({
                url: "/assignments",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic videos cache update
                try {
                    const res = await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getAssignmentsForAdmin", undefined, (draft) => {
                            draft.push(res.data);
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
            invalidatesTags: ["getVideosForAssignAssignment"]
        }),
        editAssignment: builder.mutation({
            query: ({ id, data }) => ({
                url: `/assignments/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic videos cache update
                try {
                    const res = await queryFulfilled;
                    dispatch(EditDone);
                    dispatch(
                        apiSlice.util.updateQueryData("getAssignmentsForAdmin", undefined, (draft) => {
                            return draft.map(item => {
                                if (Number(item.id) === Number(arg.id)) {
                                    return { ...res.data }
                                } else {
                                    return item
                                }
                            })
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
        }),
        updateAssignmentMark: builder.mutation({
            query: ({ id, data }) => ({
                url: `/assignmentMark/${id}`,
                method: "PATCH",
                body: data
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic assignment cache update
                const result = dispatch(
                    apiSlice.util.updateQueryData("getAssignmentMark", undefined, (draft) => {
                        return draft.map(item => Number(item.id) === Number(arg.id) ? { ...item, status: arg.data?.status, mark: arg.data?.mark } : item)
                    }))

                try {
                    await queryFulfilled;
                } catch (err) {
                    result.undo();
                }
            },
        }),
    }),
});

export const {
    useGetAssignmentAndMarkQuery,
    useGetAssignmentMarkQuery,
    useAssignmentSubmitMutation,
    useGetAssignmentsForAdminQuery,
    useDeleteAssignmentMutation,
    useAddAssignmentMutation,
    useEditAssignmentMutation,
    useUpdateAssignmentMarkMutation
} = assignmentApi;